import { Component, computed, input, signal } from '@angular/core';
import { AnimateOpenDirective } from '../../../../shared/directives/animate-open.directive';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';

@Component({
  selector: 'app-electrical-safety',
  imports: [AnimateOpenDirective, SkeletonLoaderComponent],
  templateUrl: './electrical-safety.component.html',
  styleUrl: './electrical-safety.component.scss',
  host: {
    class: 'p-24 md-p-16',
  },
})
export class ElectricalSafetyComponent {
  loading = input.required<boolean>();
  open = signal(false);

  protected viewModel = computed(() => {
    return {
      open: this.open(),
      loading: this.loading(),
    };
  });

  get vm() {
    return this.viewModel();
  }
}
